import { createSlice } from "@reduxjs/toolkit";

const initialState = {
    authData: {},
};

const authdataslice = createSlice({
    name: "authToken",
    initialState,
    reducers: {
        setAuthData: (state, action) => {
            state.authData = action.payload
        },
    },
});

export const { setAuthData} = authdataslice.actions;
export default authdataslice.reducer;
